import { TripType } from '../models/TripType';
import { ABUtils } from './ABUtils';

export const isTrainsRoundTripDiscountCard = ({ isTrainsProduct, tripType }) => {
    const { railsDiscountCardsRoundTrip } = ABUtils.getABs() || {};

    return Boolean(isTrainsProduct && tripType === TripType.ROUND_TRIP && railsDiscountCardsRoundTrip);
};
